import { render, staticRenderFns } from "./CloudComputingDetails.vue?vue&type=template&id=216d1499&"
import script from "./CloudComputingDetails.vue?vue&type=script&lang=js&"
export * from "./CloudComputingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports